import React, { useRef, useEffect, useState } from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { format } from "date-fns";

export default function RaceControl() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [, setTick] = useState(0);

  const raceControl =
    useSelector(
      (state: RootState) => state.aks.v2.raceControl?.messages,
      isEqual,
    ) || {};

  const raceControlArray = Object.keys(raceControl)
    .map(Number)
    .sort((a, b) => a - b)
    .map((key) => raceControl[`${key}`]);

  // Scroll to bottom on load or new message
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [raceControlArray.length]);

  // Force re-render after 10s to clear flash highlight
  useEffect(() => {
    const timer = setTimeout(() => setTick((t) => t + 1), 10000);
    return () => clearTimeout(timer);
  }, [raceControlArray.length]);

  return (
    <div className={styles.container}>
      <div className={styles.raceControl} ref={containerRef}>
        <table className={styles.messagesTable}>
          <tbody>
            {raceControlArray.map((msg, key) => {
              if (!msg) return null;
              const dt = msg.dayTime;
              const date = new Date(dt || 0);
              const timeStr = format(date, "HH:mm:ss");
              const message = msg.text || "";
              const isNew = Date.now() - date.getTime() < 10000;

              return (
                <tr key={key} className={isNew ? styles.highlight : ""}>
                  <td className={styles.timeCol}>{timeStr}</td>
                  <td className={styles.messageCol}>{message}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
